import { useEffect, useState } from 'react';
import { getClassGroupSummaryList } from '../../../../api/utils/lms/assignment/api';
import { ClassGroupSummaryItem } from '../../../../constants/types/lms/assignment/type';
import { useAppDispatch } from '../../../../store/hook';
import { openAlert } from '../../../../store/features/modalSlice';
import { getErrorMessages } from '../../../../api/utils/util-func';
import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '../../../Loading/LoadingSpinner';
import ClassListContents from './ClassListContents';
import StatusByClassContents from './StatusByClassContents';

/**
 * 개편 LMS (교사) - 과제 관리 > 과제 현황 페이지 > 반 선택 판넬
 */
const AssignmentClassPanel = () => {
  const { classId } = useParams();

  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [classList, setClassList] = useState<ClassGroupSummaryItem[]>([]);

  useEffect(() => {
    if (!classId) return;

    const fetchAssignmentClassList = async () => {
      try {
        setIsLoading(true);

        const response = await getClassGroupSummaryList({
          classId,
        });

        setClassList(response.groups ?? []);
      } catch (error) {
        dispatch(openAlert({ message: getErrorMessages(error) }));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssignmentClassList();
  }, [classId, dispatch]);

  const [selectedClass, setSelectedClass] =
    useState<ClassGroupSummaryItem | null>(null);

  const handleClassClick = (classItem: ClassGroupSummaryItem) => {
    setSelectedClass(classItem);
  };

  const handleBack = () => {
    setSelectedClass(null);
  };

  if (isLoading) {
    return <LoadingSpinner message="데이터 조회중" />;
  }

  return (
    <>
      {selectedClass ? (
        <StatusByClassContents
          selectedClass={selectedClass}
          handleBack={handleBack}
        />
      ) : (
        <ClassListContents
          classList={classList}
          handleClassClick={handleClassClick}
        />
      )}
    </>
  );
};

export default AssignmentClassPanel;
